// Chakra imports
import {
	Box,
	Button,
	Flex,
	Image,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card.js';
// Assets
import React from 'react';
import ModalEdit from 'views/admin/marketplace/components/ModalEdit';

export default function Article(props) {
	const { largeImage, smallImage, category, title, subtitle, id, isPublished, content, optionalImage, artists, artistId } = props;
	const tokenUser = localStorage.getItem('accessToken');
	const textColor = useColorModeValue('navy.700', 'white');

	const publishArticle = (id) => {
		const myHeaders = new Headers();
		myHeaders.append('Access-Control-Allow-Origin', '*');
		myHeaders.append('Content-Type', 'application/json; charset=UTF-8');
		myHeaders.append('Authorization', `Bearer ${tokenUser}`);

		const raw = JSON.stringify({ isPublished: true });
		const requestOptions = {
			method: 'PATCH',
			headers: myHeaders,
			body: raw
		};
		fetch(
			`${process.env.REACT_APP_URL_SERVER}/v1/articles/${id}`,
			requestOptions
		)
			.then((response) => {
				return response;
			})
			.then((response) => {
				window.location.reload();
			})
			.catch(function (error) {
				console.error(error);
			});
	};

	const deleteArticle = (id) => {
		const myHeaders = new Headers();
		myHeaders.append('Access-Control-Allow-Origin', '*');
		myHeaders.append('Content-Type', 'application/json; charset=UTF-8');
		myHeaders.append('Authorization', `Bearer ${tokenUser}`);
		const requestOptions = {
			method: 'DELETE',
			headers: myHeaders,
		};
		fetch(
			`${process.env.REACT_APP_URL_SERVER}/v1/articles/${id}`,
			requestOptions
		)
			.then((response) => {
				return response;
			})
			.then((response) => {
				window.location.reload();
			})
			.catch(function (error) {
				console.error(error);
			});
	};
	return (
		<Card p="20px">
			<Flex direction={{ base: 'column' }} justify="center">
				<Box mb={{ base: '20px', '2xl': '20px' }} position="relative">
					<Image
						src={smallImage}
						w={{ base: '100%', '3xl': '100%' }}
						h={{ base: '100%', '3xl': '100%' }}
						borderRadius="20px"
					/>
					<Button
						position="absolute"
						bg="white"
						_hover={{ bg: 'whiteAlpha.900' }}
						_active={{ bg: 'white' }}
						_focus={{ bg: 'white' }}
						p="5px !important"
						top="14px"
						left="14px"
						borderRadius="8px"
					>
						<Text
							color={textColor}
							fontSize={{
								base: 'small',
								md: 'small',
								lg: 'small',
								xl: 'small',
								'2xl': 'small',
								'3xl': 'small',
							}}
							fontWeight="bold"
						>
							{category}
						</Text>
					</Button>
				</Box>
				<Flex flexDirection="column" justify="space-between" h="100%">
					<Flex
						justify="space-between"
						direction={{
							base: 'row',
							md: 'column',
							lg: 'row',
							xl: 'column',
							'2xl': 'row',
						}}
						mb="auto"
					>
						<Flex direction="column">
							<Text
								color={textColor}
								fontSize={{
									base: 'xl',
									md: 'lg',
									lg: 'lg',
									xl: 'lg',
									'2xl': 'md',
									'3xl': 'lg',
								}}
								mb="5px"
								fontWeight="bold"
								me="14px"
							>
								{title}
							</Text>
							<Text
								color="secondaryGray.600"
								fontSize={{
									base: 'sm',
								}}
								fontWeight="400"
								me="14px"
							>
								{subtitle}
							</Text>
						</Flex>
					</Flex>
					<Flex
						align="start"
						justify="space-between"
						direction={{
							base: 'row',
							md: 'column',
							lg: 'row',
							xl: 'column',
							'2xl': 'row',
						}}
						mt="25px"
					>
						<Button
							colorScheme={'red'}
							color="white"
							fontSize="sm"
							fontWeight="500"
							borderRadius="70px"
							px="24px"
							py="5px"
							onClick={() => {
								deleteArticle(id);
							}}
						>
							Supprimer
						</Button>
						<ModalEdit id={id} optionalImage={optionalImage} subtitle={subtitle} category={category}
							title={title} content={content} smallImage={smallImage} largeImage={largeImage}
							artistId={artistId} artists={artists}
						/>
						{!isPublished ? (
							<Button
								colorScheme={'blue'}
								color="white"
								fontSize="sm"
								fontWeight="500"
								borderRadius="70px"
								px="24px"
								py="5px"
								onClick={() => {
									publishArticle(id);
								}}
							>
								Publier
							</Button>
						) : (
							<><p style={{ color: 'green' }}>Déjà publié</p></>
						)}
					</Flex>
				</Flex>
			</Flex>
		</Card>
	);
}
